// FormFactory.js

import useCursoDisciplinaForm from '@/hooks/cursodisciplina.js';
import useDocente from '@/hooks/docente.js';
import useAvaliacaoForm from '@/hooks/avaliacao.js';
import useSalaForm from '@/hooks/sala.js';

export const FormsTypes = {
  CursoDisciplina: 1,
  Docente: 4,
  Avaliacao: 3,
  Salas: 2
}

export function getFormHook(formType) {
  switch(formType){
    case FormsTypes.CursoDisciplina:
      return (isSmallWindow, filters) => {
        return useCursoDisciplinaForm(isSmallWindow, filters);
      }
    case FormsTypes.Docente:
      return (isSmallWindow, filters) => {
        return useDocente(isSmallWindow, filters);
      }
    case FormsTypes.Avaliacao:
      return (isSmallWindow, filters) => {
        return useAvaliacaoForm(isSmallWindow, filters);
      }
    case FormsTypes.Salas:
      return (isSmallWindow, filters) => {
        return useSalaForm(isSmallWindow, filters);
      }
    default:
      throw new Error(`Invalid form type: ${formType}`);
  }
}
